<template>
    <div>
        <modal-banner />
        <dashboard-1 v-if="view_new_dashboard"></dashboard-1>
        <dashboard v-else></dashboard>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { getAcls, validarPermisoComponente } from '../../plugins/acl';
import Dashboard from '../Dashboard.vue';
import Dashboard1 from '../dashboard/Index.vue';
import ModalBanner from '../banners/modal_banner.vue';

export default {
    name: 'home',
    components: {
        Dashboard,
        Dashboard1,
        ModalBanner
    },
    data() {
        return {
            view_new_dashboard: null
        };
    },
    created() {
        this.view_new_dashboard = validarPermisoComponente('ver-dashboard-general');

        const acls = getAcls();
        if (acls.info_empresa) {
            const empresa = acls.info_empresa;   
                    
            if (empresa.banner) {
                this.obtenerImagenesBanner(empresa.id).then(() => {
                    if (this.imagenes_banner && this.imagenes_banner.length) {
                        this.establecerModalBanner(true);
                    }
                });
            }
        }
    },
    computed: {
        ...mapState('banners', ['imagenes_banner'])
    },
    methods: {
        ...mapActions('banners', ['obtenerImagenesBanner']),
        ...mapMutations('banners', ['establecerModalBanner'])
    }
};
</script>
